
<div class="min-h-screen flex flex-column surface-ground">
 <app-nav-bar></app-nav-bar> 
<router-outlet>
</router-outlet>
<app-test-environment-footer *ngIf="!isProdEnv"></app-test-environment-footer>

</div>